import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'

import urls from '../urls.json'

async function sendHelpMessage(data, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, data)
  const onDoneEvent =
    parsedResponse.statusCode == 200 ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  const url = urls.sendHelpMessage

  const userData = await self.servicesVars.getUserData()

  console.log(data)
  const requestData = {
    userId: userData.reference,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    subject: data.subject,
  }

  console.log(requestData)

  const response = await Network.sendPostRequest(url, requestData)
  return response
}

function parseResponse(response, data) {
  if (
    response &&
    response.status.code === 200 &&
    response.response.statusCode == 200
  ) {
    return {
      statusCode: 200,
    }
  }
  // if (data.subject == 'testsuccess') {
  //   return { statusCode: 200 }
  // }
  if (response.status.code === 0) {
    return {
      success: false,
      message: 'error',
      networkError: true,
    }
  }
  return {
    success: false,
    message: 'error',
  }
}

export { sendHelpMessage }
